import { t } from 'src/i18n';

export function leavePeriodPhrases(type: string): string {
  switch (type) {
    case 'vacation':
      return t('periods.phrases.vacation');
    case 'leave':
      return t('periods.phrases.leave');
    case 'timeOff':
      return t('periods.phrases.timeOff');
    case 'seminar':
      return t('periods.phrases.seminar');
    case 'jobTravel':
      return t('periods.phrases.jobTravel');
    case 'homeOffice':
      return t('periods.phrases.homeOffice');
    case 'sickLeave':
      return t('periods.phrases.sickLeave');
    case 'sickSelf':
      return t('periods.phrases.sickSelf');
    case 'sickChildren':
      return t('periods.phrases.sickChildren');
    case 'OTHER':
      return t('periods.phrases.other');
  }

  throw new Error('Illegal state (E903), leave period type ' + type);
}
